import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import {
  normalizeVoiceStyleForProvider,
  providerStyleFieldLabel,
  shouldShowProviderStyleSelect,
  voiceStyleOptionsForTtsProvider,
} from '@/lib/ttsProviderStyles';

/**
 * Style / preset picker for the active TTS provider (sits beside provider select).
 */
export function TtsProviderStyleSelect({
  provider,
  value,
  onChange,
  disabled = false,
  murfVoices = [],
  murfVoiceId = '',
  murfLocale = '',
  language = 'en',
  className = '',
  triggerClassName = '',
  triggerStyle,
  testId = 'tts-provider-style-select',
  showLabel = false,
  labelClassName = 'text-[11px] font-medium',
}) {
  if (!shouldShowProviderStyleSelect(provider)) return null;

  const options = voiceStyleOptionsForTtsProvider(provider, {
    murfVoices,
    murfVoiceId,
    murfLocale,
    language,
  });
  const normalized = normalizeVoiceStyleForProvider(provider, value, {
    murfVoices,
    murfVoiceId,
    murfLocale,
    language,
  });

  return (
    <div className={className} data-testid={`${testId}-field`}>
      {showLabel ? (
        <span className={labelClassName} style={{ color: 'var(--text-primary)' }}>
          {providerStyleFieldLabel(provider)}
        </span>
      ) : null}
      <Select
        value={normalized}
        onValueChange={onChange}
        disabled={disabled || options.length === 0}
      >
        <SelectTrigger
          className={triggerClassName}
          style={triggerStyle}
          data-testid={testId}
        >
          <SelectValue placeholder={providerStyleFieldLabel(provider)} />
        </SelectTrigger>
        <SelectContent>
          {options.map((o) => (
            <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
